export default "__VITE_ASSET__6108fc2a__"